<div (click)="pickerOpen = !pickerOpen" class="picker-btn">
  <span class="chevron">
  <img *ngIf="icon && icon.Url" src="{{icon.Url}}"/>
    </span>
  <ul *ngIf="pickerOpen">
    <li *ngFor="let icon of icons" (click)="onSelect(icon.Id)">
      <img src="{{icon.Url}}"/>
    </li>
  </ul>
</div>
